// src/firebase.js

import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'

const firebaseConfig = {
  apiKey:            'AIzaSyAPaU1b--njyntNB9XbMXH1qXdpUnWw_KQ',
  authDomain:        'club-de-beneficios-maja.web.app',
  projectId:         'club-de-beneficios-maja',
  storageBucket:     'club-de-beneficios-maja.firebasestorage.app',
  messagingSenderId: '345212374367',
  appId:             '1:345212374367:web:5cd029be26b87b53cbfaea',
  measurementId:     'G-T01R2K0EDY',
}

const app  = initializeApp(firebaseConfig)
const auth = getAuth(app)
const db   = getFirestore(app)
const storage  = getStorage(app)
const functions = getFunctions(app, 'us-central1')

const googleProvider = new GoogleAuthProvider()
googleProvider.setCustomParameters({ prompt: 'select_account' })

// ─── Emuladores (solo en desarrollo local) ────────────────────────────────────
//
// En modo local SIEMPRE se conecta a los emuladores.
// Si los emuladores no están corriendo, la app muestra un error y no inicia.
// Esto garantiza que el entorno local NUNCA lee ni escribe datos de producción.

export const EMULATORS_REQUIRED =
  process.env.NODE_ENV === 'development' || process.env.REACT_APP_USE_EMULATORS === 'true'

// Emuladores desactivados temporalmente — conectado a producción
// if (EMULATORS_REQUIRED) {
//   try {
//     connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
//     connectFirestoreEmulator(db, 'localhost', 8080)
//     connectFunctionsEmulator(functions, 'localhost', 5001)
//   } catch {}
// }

export { auth, db, storage, googleProvider, functions }
